// extracted by mini-css-extract-plugin
module.exports = {"item":"Legend_item__24PCp","item_hidden":"Legend_item_hidden__3R3Y4","icon":"Legend_icon__1bXhH"};